/**
 * @Author: chengzh
 * @Date:   2021-07-07 10:05:16
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-09-15 14:19:39
 */
import App from 'next/app';
import React from 'react';
import { ConfigProvider } from 'antd';
import { createIntl, createIntlCache, IntlProvider } from 'react-intl';
import { wrapper } from '@/store/store';
import { analytics } from '@/utils/analytics';
import { sentry } from '@/utils/sentry';
// import '@/utils/GTM';
import { getEnv } from '@/utils/index';
import { localStorage, sessionStorage } from '@/utils'
import {
  init
} from 'fe-monitor-sdk';
import { initLogger } from '@/utils/sentryLogger';
import { initSensors } from '@/utils/sensors';

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();
//导入中英文对象
// import _ES from '../locales/es-ES';
import _EN from '../locales/en-US';
import _PT from '../locales/pt-BR';
import _ZH from '../locales/zh-CN';
import _TW from '../locales/zh-TW';
import _JP from '../locales/ja-JP';
import _AR from '../locales/ar-EG';

const _ENV = getEnv()
console.log("_env", _ENV)
const prod = _ENV === 'production';
if (prod) { 
  console.log = function () {}
  console.error = function(){}
  console.dir = function(){}
}

class MyApp extends App {
  static async getInitialProps ({ Component, ctx }) {
    let pageProps = {};
    let isMobileView = (ctx.req
      ? ctx.req.headers['user-agent']
      : navigator.userAgent
    ).match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|harmony.*Mobile|harmony.*Phone|ArkWeb.*Mobile/i,
    );

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    // Get the `locale` and `messages` from the request object on the server.
    // In the browser, use the same values that the server serialized.
    const { req } = ctx;
    const { locale, messages } = req || window.__NEXT_DATA__.props;

    return { pageProps, locale, messages, isMobileView: Boolean(isMobileView) };
  }

  componentDidMount () {
    const style = document.getElementById('server-side-styles');

    if (style) {
      style.parentNode.removeChild(style);
    }
    
    console.log(123)

    // 初始化监控
    init({
      env: _ENV, // 环境
      appId: 'celerpay-checkout-counter', // 应用名，同CMDB
    })

    // js错误监控
    sentry();

    // 初始化神策埋点
    initSensors();
    
    // 初始化日志收集
    initLogger();

    // 仅测试环境 + H5：vConsole 联调。勿在文件顶部 static import vconsole（SSR 会报错），仅在此动态加载
    if (_ENV === 'test' && this.props.isMobileView) {
      import('vconsole').then((mod) => {
        const VConsole = mod.default || mod;
        if (!window.__VCONSOLE_INSTANCE__ && VConsole) {
          window.__VCONSOLE_INSTANCE__ = new VConsole();
        }
      }).catch(() => {});
    }
  }

  getLocale (languages) {
    const appLocale = this.getLocaleDatas(languages);
    // addLocaleData(...appLocale.data);
    return appLocale;
  }


  getLocaleDatas (lang) {
    let result = {};
    switch (lang) {
      // case 'es-ES':
      //   result = _ES;
      //   break;
      case 'en-US':
        result = _EN;
        break;
      case 'pt-BR':
        result = _PT;
        break;
      case 'zh-CN':
        result = _ZH;
        break;
      case 'zh-TW':
        result = _TW;
        break;
      case 'ja-JP':
        result = _JP;
        break;
      // case 'ar-EG':
      //   result = _AR;
      //   break;
      default:
        result = _EN;
    }
    return result;
  }
  getLocalstorageLocale () {
    return localStorage.getItem('locale');
  }

  render() {
  console.log(1234567890);
    const {
      Component,
      pageProps,
      locale,
      messages,
      router,
      isMobileView,
    } = this.props;
    let defaultLanguage;
    let localstorageLocale;
    /** 国际化多语言逻辑，如果本地缓存存在多语言信息，就从本地取，如果不存在，就从浏览器navigator对象中取，如果是navigator对象的多语言为zh-CN，由于没有这个多语言，所以默认则改为en-US。
     * typeof window !== 'undefined' 这句话非常重要，因为第一次node服务端将不渲染浏览器对象
     */
    if (typeof window !== 'undefined') {
      // 国寿项目会有问题，参考链接https://juejin.cn/post/6844904128557105166
      // if (navigator.cookieEnabled === false) {
      //   return (
      //     <div>
      //       <p>请您开启浏览器阻止的第三方Cookie。 </p>
      //       <p>
      //         开启此设置后，网站无法使用Cookie来跟踪您在网上的活动。某些网站上的功能可能会无法正常运作。
      //       </p>
      //     </div>
      //   );
      // }
      // 初始化页面进入时间
      const llPay_startTime = new Date().getTime();
      sessionStorage.setItem('llPay_startTime', llPay_startTime);
      localStorage.setItem('isMobileView', isMobileView ? 'H5' : 'WEB');

      localstorageLocale = this.getLocalstorageLocale();
      // 兼容IE、火狐、Chrome、Safari等浏览器
      const navigatorLang = (
        navigator.language || navigator.browserLanguage
      ).toLowerCase();
      
      if (localstorageLocale) {
        defaultLanguage = localstorageLocale;
      } 
      else if (navigatorLang.includes('pt')) {
        localStorage.setItem('locale', 'pt-BR');
        defaultLanguage = 'pt-BR';
      } else if (navigatorLang.includes('zh-cn')) {
        localStorage.setItem('locale', 'zh-CN');
        defaultLanguage = 'zh-CN';
      } else if (navigatorLang.includes('zh-tw')) {
        localStorage.setItem('locale', 'zh-TW');
        defaultLanguage = 'zh-TW';
      }else if(navigatorLang.includes('ja')){
        localStorage.setItem('locale', 'ja-JP');
        defaultLanguage = 'ja-JP';
      } else if(navigatorLang.includes('ar')){
        localStorage.setItem('locale', 'ar-EG');
        defaultLanguage = 'ar-EG';
      } else if (
        navigatorLang.includes('es') ||
        !navigatorLang.includes('pt') ||
        !navigatorLang.includes('zh') ||
        !navigatorLang.includes('ja')
      ) {
        // 当地语言中如果不存在en-US 或者是 es_ES的，默认使用en-US
        localStorage.setItem('locale', 'en-US');
        defaultLanguage = 'en-US';
      }
    }
    // router.query.lang当前语言 - 需要通过修改server.js传入query.lang
    // 根据url设置语言
    const languages = defaultLanguage || 'en-US';
    const appLocale = this.getLocale(languages);
    return (
      <ConfigProvider locale={appLocale.antd.locale}>
        <IntlProvider
          key={'en'}
          locale={appLocale.locale}
          // 语言包对象嵌套
          // messages={Flat(appLocale.messages)}
          // 默认
          messages={appLocale.messages}
          formats={appLocale.formats}
        >
          <Component
            {...pageProps}
            router={router}
            isMobileView={isMobileView}
          />
        </IntlProvider>
      </ConfigProvider>
    );
  }
}

export default wrapper.withRedux(MyApp);
